/* eslint no-param-reassign:  ["error", { "props": false }] */
/* eslint no-shadow: 0 */

import { get } from 'lodash';
import { searchSkills } from '@/api';
import { SKILL_LIST } from '@/store/mutation-types';

const state = {
  skills: [],
};


const getters = {
  list(state) {
    return state.skills;
  },
};


const actions = {
  searchSkills({ commit }, input) {
    const userToken = this.getters['auth/userToken'];
    searchSkills(userToken, input)
      .then(({ data }) => {
        const status = get(data, '[1].status');
        const skills = get(data, '[1].data.details');
        if (status === 'SUCCESS') {
          commit(SKILL_LIST, skills);
        }
      })
      .catch(() => {
        // TODO: handle the error
        // console.log(error);
      });
  },
};


const mutations = {
  [SKILL_LIST](state, skills) {
    state.skills = skills;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/skills.js